import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IModal from '@/js/components/molecules/IModal.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'SendRequestFinished',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, null, {
    default: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.title)
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "icon-envelope-o" }, null, -1),
        _createTextVNode("再出品メールに登録しました")
      ]), 2),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "メールが届かない場合、ご入力いただいたメールアドレスに誤りがある、またはiichi.comのドメイン許可設定がされていない場合がございます。", -1))
    ]),
    _: 1,
    __: [1,2]
  }))
}
}

})